import app from '@/app';
import templateUrl from './home.html';

/* @ngInject */
function Controller($scope, Principal, LoginService) {
	var $ctrl = this;

	$ctrl.account = null;
	$ctrl.isAuthenticated = Principal.isAuthenticated;
	$ctrl.login = LoginService.open;

	// Hardcoded instance guard: some modules are only released for the contracted
	// domains (same rule used to show the "Sincronizar Kartado" button in asBuilt).
	$ctrl.isInstance = isInstance;

	$scope.$on('authenticationSuccess', function() {
		getAccount();
	});

	getAccount();

	function getAccount() {
		Principal.identity().then(account => {
			$ctrl.account = account;
		});
	}

	// Accepts a comma-separated list, mirroring the has-authority syntax.
	function isInstance(domains) {
		const baseUrl = $ctrl.account && $ctrl.account.baseUrl;
		if (!baseUrl) {
			return false;
		}
		const current = baseUrl.replace(/\/+$/, '');
		return domains.split(',').some(domain => current === 'https://' + domain.trim());
	}
}

var component = {
	templateUrl,
	controller: Controller
};

app.component('home', component);
